import { MouseEvent } from "react";

function WvMap({ county, setCounty }) {
  function handleClick(event: MouseEvent<SVGPathElement>) {
    let newCounty;
    const target = event.target as SVGPathElement;

    // new selection doesnt equal old selection
    if (target.id !== county) {
      newCounty = target.id;
      target.classList.add("selected-county");

      // if clicking on new county, remove class from old county
      const oldCountyElement = document.getElementById(county);
      oldCountyElement?.classList.remove("selected-county");
    } else {
      newCounty = "";
      target.classList.remove("selected-county");
    }

    setCounty(newCounty);
  }

  return (
    <svg
      height="100%"
      version="1.1"
      width="100%"
      xmlns="http://www.w3.org/2000/svg"
      overflow="hidden"
      viewBox="0 0 960 720"
    >
      <path
        id="wetzel"
        className="county green-county"
        strokeLinejoin="round"
        cursor="pointer"
        fill="transparent"
        stroke="black"
        d="M380.5744,221.18453L390.36440000000005,218.43453L392.56440000000003,205.23453999999998L397.5144,198.41454L424.7944,198.19454L446.13439999999997,198.08453999999998L449.8744,198.08453999999998L461.3144,198.08453999999998L465.38439999999997,206.11453999999998L465.38439999999997,214.80453999999997L459.5544,214.47453999999996L456.9144,223.16453999999996L452.6244,222.94453999999996L449.65439999999995,229.76453999999995L453.83439999999996,245.16453999999996L450.3144,248.46453999999997L447.01439999999997,254.84453999999997L442.5044,256.60454L436.5644,252.20453999999998L431.0644,252.42453999999998L413.13439999999997,244.28454L412.03439999999995,239.99454L405.21439999999996,235.15454L394.76439999999997,222.17454L389.4844,226.57454Z"
        fillRule="evenodd"
        strokeWidth="1"
        data-hasqtip="0"
        strokeDasharray="0"
        onClick={handleClick}
      ></path>
      <path
        id="nicholas"
        className="county green-county"
        strokeLinejoin="round"
        cursor="pointer"
        fill="transparent"
        stroke="black"
        d="M385.7444,459.88454L400.5944,447.12454L399.2744,443.93454L390.4744,441.40454000000005L405.5444,431.28454000000005L411.0444,437.66454000000004L413.13439999999997,436.34454000000005L426.77439999999996,437.4445400000001L422.3744,442.0645400000001L428.4244,457.90454000000005L425.1244,460.21454000000006L430.8444,471.8745400000001L433.3744,470.9945400000001L460.76439999999997,489.14454000000006L445.6944,503.0045400000001L417.4244,526.98454L390.4744,522.25454L379.8044,509.27454L380.6844,504.10454L374.4144,498.38453999999996L370.6744,501.79454L362.7544,498.27454L361.4344,502.89454L347.6844,497.61454000000003L335.2544,490.13454L335.2544,490.13454Z"
        fillRule="evenodd"
        strokeWidth="1"
        data-hasqtip="1"
        strokeDasharray="0"
        onClick={handleClick}
      ></path>
      <path
        id="clay"
        className="county blue-county"
        strokeLinejoin="round"
        cursor="pointer"
        fill="transparent"
        stroke="black"
        d="M385.7444,459.88454L335.2544,490.13454L335.2544,490.13454L331.7344,467.80454000000003L327.1144,448.33454000000006L341.3044,437.33454000000006L351.3144,429.6345400000001L358.6844,420.39454000000006L360.5544,417.7545400000001L366.82439999999997,409.28454000000005L375.6244,417.7545400000001L376.5044,424.1345400000001L383.4344,426.9945400000001L384.7544,433.8145400000001L388.82439999999997,435.46454000000006L390.47439999999995,441.40454000000005L399.27439999999996,443.93454L400.59439999999995,447.12454Z"
        fillRule="evenodd"
        strokeWidth="1"
        data-hasqtip="2"
        strokeDasharray="0"
        onClick={handleClick}
      ></path>
      <path
        id="berkeley"
        className="county green-county"
        strokeLinejoin="round"
        cursor="pointer"
        fill="transparent"
        stroke="black"
        d="M833.5544,282.34453L813.6444,267.16453L802.4244,257.92453L806.4944,247.80453L810.3444000000001,230.97453000000002L815.0744000000001,217.00453000000002L822.0044,219.09453000000002L833.0044,211.28453000000002L835.5344,214.80453000000003L842.9044,213.04453000000004L845.3244,217.88453000000004L846.7543999999999,211.06454000000005L853.6843999999999,215.02454000000006L854.0143999999999,211.61454000000006L861.1643999999999,212.93453000000005L862.2643999999999,220.85453000000004L854.3444,222.50453000000005L858.6343999999999,231.52453000000006L864.2443999999999,235.48453000000006L861.2743999999999,244.94453000000007L848.7343999999999,258.4745300000001L843.2343999999999,261.55453000000006L840.1543999999999,271.01454000000007Z"
        fillRule="evenodd"
        strokeWidth="1"
        data-hasqtip="3"
        strokeDasharray="0"
        onClick={handleClick}
      ></path>
      <path
        id="tyler"
        className="county grey-county"
        strokeLinejoin="round"
        cursor="pointer"
        fill="transparent"
        stroke="black"
        d="M352.9644,251.10454L357.4744,243.40454L365.8344,234.60454L380.5744,221.18454L389.48440000000005,226.57453999999998L394.7644,222.17453999999998L405.2144,235.15453999999997L412.0344,239.99453999999997L413.1344,244.28453999999996L431.06440000000003,252.42453999999998L424.79440000000005,255.94454L416.10440000000006,256.71454L413.1344,263.53454L398.2844,273.98454L389.1544,283.77454L389.9244,270.46454L382.3344,264.85454L377.6044,274.75453999999996L370.5644,272.44453999999996L367.26439999999997,249.12453999999997L362.3144,247.36453999999998Z"
        fillRule="evenodd"
        strokeWidth="1"
        data-hasqtip="4"
        strokeDasharray="0"
        onClick={handleClick}
      ></path>
      <path
        id="fayette"
        className="county green-county"
        strokeLinejoin="round"
        cursor="pointer"
        fill="transparent"
        stroke="black"
        d="M335.2544,490.13454L347.6844,497.61454000000003L361.4344,502.89454L362.7544,498.27454L370.6744,501.79454L374.4144,498.38453999999996L380.6844,504.10454L379.8044,509.27454L390.4744,522.25454L388.6044,526.98454L393.6644,531.49454L403.4544,530.61454L398.8344,534.24454L403.8944,537.87454L408.2944,545.79454L401.8044,553.05454L411.70439999999996,569.88454L402.57439999999997,569.11454L392.01439999999997,573.84454L380.57439999999997,579.12454L375.2944,576.37454L362.7544,575.8245400000001L360.2244,567.7945400000001L325.0244,565.0445400000001L324.8044,554.0445400000001L316.7744,547.4445400000001L311.49440000000004,548.98454L319.41440000000006,509.27454000000006L335.25440000000003,490.1345400000001Z"
        fillRule="evenodd"
        strokeWidth="1"
        data-hasqtip="5"
        strokeDasharray="0"
        onClick={handleClick}
      ></path>
      <path
        id="kanawha"
        className="county green-county"
        strokeLinejoin="round"
        cursor="pointer"
        fill="transparent"
        stroke="black"
        d="M335.2544,490.13454L319.4144,509.27454L311.4944,548.98454L302.3644,549.2045400000001L299.5044,545.24454L298.95439999999996,537.3245400000001L294.22439999999995,529.2945300000001L286.7443999999999,527.4245300000001L290.2643999999999,520.1645300000001L281.7943999999999,515.2145400000002L276.62439999999987,507.7345300000002L269.3643999999999,505.5345300000002L270.13439999999986,498.4945400000002L257.26439999999985,498.1645300000002L255.39439999999985,502.7845300000002L251.10439999999986,496.9545300000002L240.21439999999984,500.36453000000023L244.06439999999984,498.27454000000023L244.61439999999985,483.5345400000002L242.74439999999984,478.9145400000002L232.07439999999986,479.2445400000002L227.45439999999985,477.0445400000002L229.98439999999985,462.4145400000002L240.32439999999986,456.3645400000002L257.59439999999984,449.1045400000002L253.19439999999983,437.5545400000002L253.85439999999983,424.1345400000002L262.4343999999998,417.09454000000017L272.3343999999998,431.61454000000015L280.9143999999998,427.10454000000016L289.8243999999998,420.06454000000014L292.0243999999998,426.11454000000015L298.6243999999998,432.71454000000017L324.1443999999998,435.79454000000015L328.6543999999998,438.43454000000014L341.30439999999976,437.3345400000001L327.11439999999976,448.3345400000001L331.73439999999977,467.8045400000001L335.25439999999975,490.1345400000001Z"
        fillRule="evenodd"
        strokeWidth="1"
        data-hasqtip="6"
        strokeDasharray="0"
        onClick={handleClick}
      ></path>
      <path
        id="brooke"
        className="county blue-county"
        strokeLinejoin="round"
        cursor="pointer"
        fill="transparent"
        stroke="black"
        d="M445.6944,62.234535L445.58439999999996,72.244535L445.6944,110.30454L434.03439999999995,106.89454L420.72439999999995,105.24454L423.80439999999993,96.334535L429.7443999999999,89.954535L433.15439999999995,78.73453500000001L431.9444,68.284535L428.53439999999995,63.224535L437.11439999999993,62.234535Z"
        fillRule="evenodd"
        strokeWidth="1"
        data-hasqtip="7"
        strokeDasharray="0"
        onClick={handleClick}
      ></path>
      <path
        id="ohio"
        className="county green-county"
        strokeLinejoin="round"
        cursor="pointer"
        fill="transparent"
        stroke="black"
        d="M412.8044,135.71453L411.9244,127.35454L415.9944,122.95454L417.4244,110.85454L420.7244,105.24454L434.0344,106.89454L445.69440000000003,110.30454L445.80440000000004,118.66454L445.91440000000006,139.01454L419.9544000000001,136.37453000000002Z"
        fillRule="evenodd"
        strokeWidth="1"
        data-hasqtip="8"
        strokeDasharray="0"
        onClick={handleClick}
      ></path>
      <path
        id="lincoln"
        className="county grey-county"
        strokeLinejoin="round"
        cursor="pointer"
        fill="transparent"
        stroke="black"
        d="M227.4544,477.04454L232.0744,479.24454L242.74439999999998,478.91452999999996L244.6144,483.53452999999996L244.06439999999998,498.27452999999997L240.21439999999998,500.36452999999995L237.35439999999997,507.62452999999994L231.74439999999996,508.61452999999995L232.84439999999995,514.7745399999999L225.25439999999995,511.6945299999999L221.07439999999994,518.4045299999999L217.99439999999993,532.0445299999999L228.44439999999992,536.3345299999999L224.15439999999992,537.1045299999998L206.44439999999992,539.0845299999999L183.12439999999992,546.7845299999999L173.77439999999993,549.86453L164.75439999999992,552.72453L174.87439999999992,541.39454L181.25439999999992,536.99453L183.0143999999999,531.49453L176.3043999999999,526.4345300000001L168.9343999999999,513.1245300000002L170.0343999999999,500.3645300000002L172.1243999999999,495.74453000000017L175.9743999999999,487.27453000000014L180.04439999999988,485.40453000000014L186.3143999999999,473.7445300000001L195.6643999999999,472.97453000000013L198.85439999999988,468.3545300000001L206.77439999999987,467.03453000000013L206.33439999999987,483.8645300000001L215.35439999999988,488.2645300000001Z"
        fillRule="evenodd"
        strokeWidth="1"
        data-hasqtip="9"
        strokeDasharray="0"
        onClick={handleClick}
      ></path>
      <path
        id="monongalia"
        className="county green-county"
        strokeLinejoin="round"
        cursor="pointer"
        fill="transparent"
        stroke="black"
        d="M465.3844,214.80454L465.3844,206.11454L461.31440000000003,198.08454L514.7744,197.53453000000002L563.0644,197.09453000000002L559.3244,216.56453000000002L542.6043999999999,245.27453000000003L543.4843999999999,254.51453000000004L537.7643999999999,251.76453000000004L536.5543999999999,251.21453000000002L532.0443999999999,249.12453000000002L502.8943999999999,219.86453000000003L472.86439999999993,219.86453000000003Z"
        fillRule="evenodd"
        strokeWidth="1"
        data-hasqtip="10"
        strokeDasharray="0"
        onClick={handleClick}
      ></path>
      <path
        id="harrison"
        className="county green-county"
        strokeLinejoin="round"
        cursor="pointer"
        fill="transparent"
        stroke="black"
        d="M442.5044,256.60454L447.01439999999997,254.84454L450.3144,248.46453L481.5544,255.39454L496.51439999999997,263.42454L495.96439999999996,286.52454L501.57439999999997,293.67454L492.66439999999994,307.97452999999996L492.33439999999996,319.63453999999996L489.03439999999995,322.05454L481.0044,321.50453999999996L457.3544,314.79452999999995L447.0144,313.36452999999995L434.80440000000004,309.18452999999994L443.27440000000007,304.56452999999993L445.6944000000001,300.60452999999995L439.4244000000001,298.40452999999997L442.39440000000013,295.54452999999995L436.6744000000001,291.14453L437.5544000000001,286.08453L433.4844000000001,284.32453L444.5944000000001,270.46452999999997L442.7244000000001,269.14453999999995Z"
        fillRule="evenodd"
        strokeWidth="1"
        data-hasqtip="11"
        strokeDasharray="0"
        onClick={handleClick}
      ></path>
      <path
        id="hampshire"
        className="county grey-county"
        strokeLinejoin="round"
        cursor="pointer"
        fill="transparent"
        stroke="black"
        d="M735.1044,230.97454L740.8244000000001,229.98453999999998L749.2944000000001,233.83453999999998L755.2344000000002,232.51453999999998L764.4744000000002,233.94454L769.5344000000001,237.24454L783.6144000000002,243.51454L781.8544000000002,254.95454L784.6044000000002,259.02454L781.0844000000002,264.96453L785.4844000000002,267.05454000000003L773.4944000000002,285.64454L776.6844000000002,288.28454L770.8544000000002,297.52454L776.4644000000002,303.57454L767.9944000000002,314.57454L760.6244000000002,319.74453L752.0444000000001,311.38453L745.6644000000001,309.84452999999996L742.4744000000001,314.24452999999994L731.6944000000001,308.85453999999993L725.2044000000001,308.41453999999993L699.0244000000001,299.1745399999999L686.3744000000002,291.6945399999999L694.5144000000001,283.3345399999999L700.3444000000002,273.8745399999999L706.0644000000002,272.5545399999999L712.0044000000003,263.3145399999999L718.3844000000003,249.0145399999999L724.2144000000003,245.7145399999999Z"
        fillRule="evenodd"
        strokeWidth="1"
        data-hasqtip="12"
        strokeDasharray="0"
        onClick={handleClick}
      ></path>
      <path
        id="pendleton"
        className="county grey-county"
        strokeLinejoin="round"
        cursor="pointer"
        fill="transparent"
        stroke="black"
        d="M649.3044,364.95454L664.0444,377.16454L664.0444,377.16454L664.0444,377.16454L664.0444,377.16454L664.0444,377.16454L664.0444,377.16454L664.0444,377.16454L664.0444,377.16454L664.0444,377.16454L664.0444,377.16454L670.6444,382.66454L676.3644,387.28454L670.9744000000001,399.27454L671.1944000000001,407.63454L665.1444000000001,409.17454000000004L661.1844000000001,421.27454000000006L653.9244000000001,435.2445400000001L651.1744000000001,444.5945300000001L644.7944000000001,452.40454000000005L637.6444000000001,458.01454000000007L611.5744000000001,449.4345400000001L601.7844000000001,430.8445400000001L584.0744000000001,422.9245400000001L588.6944000000001,416.6545400000001L587.3744,408.4045400000001L592.5444,408.0745400000001L591.8844,403.67454000000015L597.4944,397.62454000000014L605.3044,384.75454000000013L605.5244,380.68454000000014L600.5744,372.65454000000017L604.6444,362.09454000000017L609.1544,363.5245400000002L615.2044,360.9945400000002L613.2244,354.8345400000002L625.9843999999999,356.3745400000002L629.7244,349.0045400000002Z"
        fillRule="evenodd"
        strokeWidth="1"
        data-hasqtip="13"
        strokeDasharray="0"
        onClick={handleClick}
      ></path>
      <path
        id="grant"
        className="county grey-county"
        strokeLinejoin="round"
        cursor="pointer"
        fill="transparent"
        stroke="black"
        d="M664.0444,377.16453L649.3044,364.95453000000003L629.7244,349.00453000000005L629.8344,348.78453L628.5143999999999,347.57453000000004L630.8243999999999,346.80453000000006L635.6643999999999,334.26454000000007L637.4243999999999,325.68453000000005L628.4043999999999,323.1545300000001L632.0343999999999,316.55453000000006L631.9243999999999,310.83453000000003L638.4143999999999,302.25453000000005L631.4843999999999,297.41453000000007L622.2443999999999,301.9245400000001L610.6944,305.0045400000001L607.5043999999999,301.8145400000001L607.5043999999999,301.8145400000001L607.5043999999999,301.3745400000001L607.5043999999999,299.6145400000001L617.1843999999999,295.2145400000001L629.1743999999999,281.5745400000001L637.8643999999999,280.25454000000013L640.6143999999999,274.5345400000001L661.9544,277.2845400000001L686.3743999999999,291.69454000000013L678.0143999999999,309.5145400000001L678.0143999999999,315.56454000000014L673.6143999999999,322.16454000000016L670.0944,332.06454000000014L671.5243999999999,339.6545400000001L677.3543999999999,353.84453000000013L671.3044,360.88453000000015L672.1844,364.2945300000002L664.0444,377.1645300000002L664.0444,377.1645300000002L664.0444,377.1645300000002L664.0444,377.1645300000002L664.0444,377.1645300000002Z"
        fillRule="evenodd"
        strokeWidth="1"
        data-hasqtip="14"
        strokeDasharray="0"
        onClick={handleClick}
      ></path>
      <path
        id="hardy"
        className="county grey-county"
        strokeLinejoin="round"
        cursor="pointer"
        fill="transparent"
        stroke="black"
        d="M664.0444,377.16453L664.0444,377.16453L664.0444,377.16453L664.0444,377.16453L664.0444,377.16453ZM664.0444,377.16453L664.0444,377.16453L672.1844,364.29453L671.3044,360.88453L677.3543999999999,353.84452999999996L671.5243999999999,339.65453999999994L670.0944,332.06453999999997L673.6143999999999,322.16454L678.0143999999999,315.56453999999997L678.0143999999999,309.51453999999995L686.3743999999999,291.69453999999996L699.0243999999999,299.17454L725.2043999999999,308.41454L731.6943999999999,308.85454L742.4743999999998,314.24453L745.6643999999999,309.84453L752.0443999999999,311.38453000000004L760.6243999999999,319.74453000000005L757.8743999999999,323.92454000000004L750.9444,331.40454000000005L754.3543999999999,334.04453000000007L746.6543999999999,344.93453000000005L743.6843999999999,341.41453000000007L734.5543999999999,353.18453000000005L728.5043999999999,357.14454000000006L728.1743999999999,351.9745300000001L717.9443999999999,361.65454000000005L705.7343999999998,386.40454000000005L685.9343999999999,369.35454000000004L676.3643999999998,387.28454000000005L670.6443999999998,382.66454000000004L664.0443999999998,377.16454000000004Z"
        fillRule="evenodd"
        strokeWidth="1"
        data-hasqtip="15"
        strokeDasharray="0"
        onClick={handleClick}
      ></path>
      <path
        id="summers"
        className="county blue-county"
        strokeLinejoin="round"
        cursor="pointer"
        fill="transparent"
        stroke="black"
        d="M394.4344,657.33454L394.32439999999997,657.2245399999999L394.21439999999996,657.1145399999999L376.83439999999996,642.3745399999999L356.70439999999996,625.2145399999999L361.65439999999995,620.70453L360.88439999999997,614.98453L380.2444,599.9145299999999L390.58439999999996,606.8445299999998L387.9444,597.0545299999999L383.9844,594.5245299999999L388.6044,589.5745299999999L380.5744,579.1245299999998L392.0144,573.8445299999998L402.5744,569.1145299999998L411.1544,575.6045299999998L424.5744,590.2345299999998L425.3444,596.5045299999998L425.7844,599.9145299999998L411.9244,625.4345299999998L404.0044,638.5245299999998Z"
        fillRule="evenodd"
        strokeWidth="1"
        data-hasqtip="16"
        strokeDasharray="0"
        onClick={handleClick}
      ></path>
      <path
        id="cabell"
        className="county green-county"
        strokeLinejoin="round"
        cursor="pointer"
        fill="transparent"
        stroke="black"
        d="M180.2644,423.25454L199.8444,441.51454L205.7844,447.01454L206.33440000000002,461.20454L206.7744,467.03454L198.85440000000003,468.35454L195.66440000000003,472.97454L186.31440000000003,473.74454L180.04440000000002,485.40454L175.97440000000003,487.27454L172.12440000000004,495.74454000000003L166.62440000000004,493.43453000000005L165.85440000000003,482.43453000000005L170.47440000000003,480.67453000000006L167.17440000000002,475.94453000000004L159.80440000000002,480.34453L134.2844,458.67453L150.6744,453.28453L163.43439999999998,451.52453L166.7344,441.62453000000005L169.5944,424.90453L175.86440000000002,421.82453000000004Z"
        fillRule="evenodd"
        strokeWidth="1"
        data-hasqtip="17"
        strokeDasharray="0"
        onClick={handleClick}
      ></path>
      <path
        id="mason"
        className="county grey-county"
        strokeLinejoin="round"
        cursor="pointer"
        fill="transparent"
        stroke="black"
        d="M205.7844,447.01454L199.8444,441.51454L180.26440000000002,423.25453L186.31440000000003,421.71452999999997L187.74440000000004,416.54452999999995L184.99440000000004,405.54452999999995L186.31440000000003,400.48452999999995L183.67440000000005,389.81452999999993L180.37440000000004,384.0945299999999L192.69440000000003,373.31452999999993L192.91440000000003,362.0945299999999L200.06440000000003,350.10453999999993L207.43440000000004,343.0645399999999L209.74440000000004,337.0145399999999L214.69440000000003,336.0245399999999L218.54440000000002,343.0645399999999L226.0244,344.4945399999999L230.9744,354.5045399999999L226.7944,361.7645399999999L229.6544,366.3845399999999L230.5344,369.4645399999999L247.6944,395.6445399999999L244.1744,399.2745399999999L250.5544,406.0945399999999L221.7344,410.6045399999999L204.5744,420.2845399999999Z"
        fillRule="evenodd"
        strokeWidth="1"
        data-hasqtip="18"
        strokeDasharray="0"
        onClick={handleClick}
      ></path>
      <path
        id="webster"
        className="county green-county"
        strokeLinejoin="round"
        cursor="pointer"
        fill="transparent"
        stroke="black"
        d="M472.8644,497.39454L465.82439999999997,492.55454000000003L460.76439999999997,489.14454L433.3744,470.99454000000003L430.8444,471.87454L425.1244,460.21453L428.4244,457.90453L422.3744,442.06454L426.77439999999996,437.44454L448.9943999999999,413.46453L456.91439999999994,394.76454L458.89439999999996,397.18453L467.03439999999995,396.96452999999997L473.30439999999993,396.30452999999994L478.80439999999993,405.54452999999995L484.7443999999999,403.34452999999996L500.1443999999999,437.22452999999996L490.6843999999999,464.72452999999996L477.3743999999999,475.39453L473.9643999999999,473.41452999999996Z"
        fillRule="evenodd"
        strokeWidth="1"
        data-hasqtip="19"
        strokeDasharray="0"
        onClick={handleClick}
      ></path>
      <path
        id="greenbrier"
        className="county green-county"
        strokeLinejoin="round"
        cursor="pointer"
        fill="transparent"
        stroke="black"
        d="M460.7644,489.14454L465.8244,492.55454000000003L472.86440000000005,497.39454L472.53440000000006,519.72454L488.2644000000001,533.14454L503.3344000000001,535.12454L513.1244,531.05454L536.4444000000001,529.29453L528.8544,543.92453L508.06440000000003,565.81453L491.23440000000005,588.80453L489.80440000000004,598.37454L483.75440000000003,604.20453L469.56440000000003,604.09453L468.1344,599.2545399999999L459.2244,605.9645399999999L450.3144,604.53454L425.34439999999995,596.50454L424.57439999999997,590.23454L411.15439999999995,575.60454L402.57439999999997,569.11454L411.70439999999996,569.88454L401.8044,553.05454L408.2944,545.79453L403.8944,537.87454L398.8344,534.24454L403.4544,530.61454L393.6644,531.49454L388.6044,526.98454L390.4744,522.25454L417.4244,526.98454L445.6944,503.00453000000005Z"
        fillRule="evenodd"
        strokeWidth="1"
        data-hasqtip="20"
        strokeDasharray="0"
        onClick={handleClick}
      ></path>
      <path
        id="lewis"
        className="county blue-county"
        strokeLinejoin="round"
        cursor="pointer"
        fill="transparent"
        stroke="black"
        d="M467.0344,396.96453L458.8944,397.18453000000005L456.9144,394.76454000000007L458.5644,387.06453000000005L452.40439999999995,382.55453000000006L454.27439999999996,376.7245300000001L446.57439999999997,370.12453000000005L437.0044,370.89453000000003L433.4844,361.76453000000004L416.1044,340.97453L414.2344,323.48453L418.4144,324.58453000000003L425.3444,314.35453L429.5244,314.79453L434.8044,309.18453L447.01439999999997,313.36453L457.35439999999994,314.79453L481.0043999999999,321.50453L478.36439999999993,339.65452999999997L475.83439999999996,343.06453L478.47439999999995,350.65452999999997L467.80439999999993,367.48452999999995L464.3943999999999,388.8245299999999Z"
        fillRule="evenodd"
        strokeWidth="1"
        data-hasqtip="21"
        strokeDasharray="0"
        onClick={handleClick}
      ></path>
      <path
        id="preston"
        className="county green-county"
        strokeLinejoin="round"
        cursor="pointer"
        fill="transparent"
        stroke="black"
        d="M607.5044,301.37454L607.5044,301.81453000000005L607.5044,301.81453000000005L604.3144,297.63453000000004L576.1544,286.96453L557.2344,295.43453000000005L550.8544,292.24453000000005L550.3044000000001,287.07453000000004L543.7044000000001,281.68453000000005L543.7044000000001,281.68453000000005L543.4844,254.51453000000004L542.6044,245.27453000000003L559.3244000000001,216.56453000000002L563.0644000000001,197.09453000000002L607.3944000000001,196.43453000000002L607.7244000000002,234.38453000000004L607.1744000000002,234.38453000000004L607.5044000000003,299.61453000000006Z"
        fillRule="evenodd"
        strokeWidth="1"
        data-hasqtip="22"
        strokeDasharray="0"
        onClick={handleClick}
      ></path>
      <path
        id="doddridge"
        className="county green-county"
        strokeLinejoin="round"
        cursor="pointer"
        fill="transparent"
        stroke="black"
        d="M431.0644,252.42454L436.5644,252.20454L442.5044,256.60454L442.7244,269.14454L444.5944,270.46453L433.4844,284.32454L437.5544,286.08454L436.6744,291.14454L442.3944,295.54453L439.4244,298.40453L445.6944,300.60454000000004L443.27439999999996,304.56454L434.80439999999993,309.18454L429.52439999999996,314.79454000000004L425.34439999999995,314.35454000000004L418.41439999999994,324.58454000000006L414.23439999999994,323.48454000000004L410.9343999999999,322.71454000000006L401.03439999999995,320.84454000000005L385.1944,288.0645400000001L389.15439999999995,283.77454000000006L398.28439999999995,273.98454000000004L413.13439999999997,263.53454000000005L416.1044,256.71454000000006L424.7944,255.94454000000005Z"
        fillRule="evenodd"
        strokeWidth="1"
        data-hasqtip="23"
        strokeDasharray="0"
        onClick={handleClick}
      ></path>
      <path
        id="gilmer"
        className="county green-county"
        strokeLinejoin="round"
        cursor="pointer"
        fill="transparent"
        stroke="black"
        d="M401.0344,320.84453L410.9344,322.71453L414.2344,323.48453L416.1044,340.97453L433.4844,361.76453000000004L427.9844,365.72453L423.4744,364.07453000000004L418.5244,366.93453000000005L374.19440000000003,399.27453L372.2144,393.33454L366.93440000000004,390.80453L362.97440000000006,384.09453L369.90440000000007,378.37453L371.3344000000001,373.53453L369.6844000000001,358.13453000000004L371.2244000000001,350.54453000000007L366.6044000000001,340.86453000000006L371.4444000000001,340.86453000000006L377.1644000000001,335.6945400000001L385.63440000000014,333.4945400000001L390.80440000000016,328.1045400000001L397.51440000000014,326.2345400000001Z"
        fillRule="evenodd"
        strokeWidth="1"
        data-hasqtip="24"
        strokeDasharray="0"
        onClick={handleClick}
      ></path>
      <path
        id="roane"
        className="county blue-county"
        strokeLinejoin="round"
        cursor="pointer"
        fill="transparent"
        stroke="black"
        d="M358.6844,420.39454L351.3144,429.63453L341.3044,437.33454L328.6544,438.43453L324.1444,435.79453L298.62440000000004,432.71453L292.0244,426.11453L289.8244,420.06454L286.0844,408.07454L288.8344,392.89454L290.1544,377.60454L288.8344,363.52454L293.2344,359.01454L301.7044,354.28453L306.87440000000004,358.46453L317.98440000000005,363.52454L328.3244,359.67454L334.48440000000005,366.60454L333.27440000000007,372.10454L337.23440000000005,373.97452999999996L337.67440000000005,383.10454L345.37440000000004,396.63453999999996L346.91440000000006,413.90453999999994L354.94440000000003,414.89453999999995Z"
        fillRule="evenodd"
        strokeWidth="1"
        data-hasqtip="25"
        strokeDasharray="0"
        onClick={handleClick}
      ></path>
      <path
        id="barbour"
        className="county green-county"
        strokeLinejoin="round"
        cursor="pointer"
        fill="transparent"
        stroke="black"
        d="M543.7044,281.68454L550.3044,287.07454L550.8543999999999,292.24453L557.2343999999999,295.43453999999997L553.2743999999999,316.11452999999995L555.0343999999999,318.4245399999999L549.2043999999999,327.11452999999995L544.3643999999998,347.02453999999994L514.8843999999998,352.63453999999996L519.8343999999998,346.91453999999993L519.2843999999999,334.59453999999994L507.9543999999999,334.4845399999999L501.6843999999999,324.58453999999995L492.3343999999999,319.63453999999996L492.6643999999999,307.97452999999996L501.5743999999999,293.67454L504.2143999999999,294.44453999999996L523.9043999999999,292.35452999999995L533.4744,288.06452999999993L537.2144,282.23452999999995Z"
        fillRule="evenodd"
        strokeWidth="1"
        data-hasqtip="26"
        strokeDasharray="0"
        onClick={handleClick}
      ></path>
      <path
        id="mercer"
        className="county green-county"
        strokeLinejoin="round"
        cursor="pointer"
        fill="transparent"
        stroke="black"
        d="M313.9144,675.37454L317.4344,667.89454L322.1644,657.99454L326.6744,658.76454L322.82439999999997,651.06454L330.63439999999997,643.14454L336.3544,640.8345400000001L339.9844,634.4545400000001L340.0944,628.0745400000001L350.2144,623.34454L356.7044,625.21454L376.8344,642.37454L394.2144,657.11454L390.4744,666.24454L395.8644,673.61454L388.1644,679.66454L374.9644,684.50454L373.8644,682.74454L355.1644,686.92454L345.0444,690.44454L335.8044,696.05454L320.6244,683.07454Z"
        fillRule="evenodd"
        strokeWidth="1"
        data-hasqtip="27"
        strokeDasharray="0"
        onClick={handleClick}
      ></path>
      <path
        id="mcdowell"
        className="county green-county"
        strokeLinejoin="round"
        cursor="pointer"
        fill="transparent"
        stroke="black"
        d="M322.1644,657.99454L317.4344,667.89454L313.9144,675.37454L308.7444,679.66453L305.1144,688.24453L292.13439999999997,691.21454L290.70439999999996,695.8345400000001L282.01439999999997,701.4445400000001L263.20439999999996,702.3245400000001L253.41439999999997,695.0645300000001L252.42439999999996,689.8945400000001L245.60439999999997,685.6045400000002L235.26439999999997,684.8345300000002L231.96439999999996,676.8045300000002L225.14439999999996,672.5145400000002L222.28439999999995,666.5745400000002L222.50439999999995,654.5845400000002L214.58439999999996,651.2845400000002L212.82439999999997,646.7745400000002L223.93439999999998,639.8445400000003L226.90439999999998,636.8745400000003L235.37439999999998,632.5845400000003L240.10439999999997,635.3345400000003L239.66439999999997,639.6245400000003L255.50439999999998,643.5845400000003L267.4944,637.9745400000003L274.20439999999996,639.4045300000002L275.52439999999996,643.5845300000002L283.55439999999993,644.3545400000002L287.73439999999994,647.6545300000001L297.52439999999996,645.8945400000001L302.91439999999994,653.1545300000001L308.30439999999993,649.9645400000002L312.04439999999994,654.2545400000001Z"
        fillRule="evenodd"
        strokeWidth="1"
        data-hasqtip="28"
        strokeDasharray="0"
        onClick={handleClick}
      ></path>
      <path
        id="wyoming"
        className="county blue-county"
        strokeLinejoin="round"
        cursor="pointer"
        fill="transparent"
        stroke="black"
        d="M235.3744,632.58454L239.6644,623.0145399999999L243.8444,620.0445299999999L244.0644,610.3645399999999L260.2344,602.2245399999999L250.3344,592.10453L261.5544,587.70453L275.3044,584.95453L280.2544,590.01454L290.15439999999995,584.51454L298.07439999999997,585.61454L303.7944,592.98454L320.6244,623.34454L323.3744,633.5745400000001L336.3544,640.8345400000001L330.63439999999997,643.14454L322.82439999999997,651.06454L326.6744,658.76454L322.1644,657.99454L312.0444,654.25454L308.3044,649.96454L302.9144,653.1545400000001L297.5244,645.8945400000001L287.7344,647.6545400000001L283.5544,644.3545400000002L275.5244,643.5845400000002L274.2044,639.4045400000002L267.49440000000004,637.9745400000003L255.50440000000003,643.5845400000003L239.66440000000003,639.6245400000003L240.10440000000003,635.3345400000003Z"
        fillRule="evenodd"
        strokeWidth="1"
        data-hasqtip="29"
        strokeDasharray="0"
        onClick={handleClick}
      ></path>
      <path
        id="mingo"
        className="county grey-county"
        strokeLinejoin="round"
        cursor="pointer"
        fill="transparent"
        stroke="black"
        d="M244.0644,610.36454L243.8444,620.04453L239.6644,623.01454L235.3744,632.5845400000001L226.9044,636.87454L223.9344,639.84454L217.55440000000002,634.5645400000001L202.04440000000002,634.5645400000001L200.39440000000002,630.8245400000001L191.04440000000002,631.1545400000001L191.48440000000002,623.2345400000002L187.63440000000003,623.3445400000002L186.42440000000002,617.9545400000002L178.50440000000003,616.6345400000001L174.32440000000003,609.3745400000001L164.31440000000003,605.8545300000002L165.63440000000003,601.4545300000002L159.91440000000003,593.3145300000002L163.21440000000004,588.4745400000002L153.31440000000003,580.8845400000001L147.26440000000002,570.1045400000002L149.0244,568.6745300000001L164.7544,552.7245400000002L173.7744,549.8645400000001L183.1244,546.7845300000001L182.1344,548.8745400000001L187.3044,559.3245300000001L193.3544,561.9645300000001L195.2244,571.0945300000001L189.9444,573.9545300000001L192.0344,579.8945400000001L196.2144,581.6545300000001L195.9944,591.8845300000002L199.6244,601.6745300000001L206.2244,601.7845300000001L213.9244,613.5545300000001L215.90439999999998,608.6045300000001L223.82439999999997,605.8545300000001L227.56439999999998,609.7045300000001L233.28439999999998,606.2945300000001Z"
        fillRule="evenodd"
        strokeWidth="1"
        data-hasqtip="30"
        strokeDasharray="0"
        onClick={handleClick}
      ></path>
      <path
        id="pleasants"
        className="county grey-county"
        strokeLinejoin="round"
        cursor="pointer"
        fill="transparent"
        stroke="black"
        d="M331.1844,284.10454L321.39439999999996,282.89454L321.39439999999996,279.26454L315.23439999999994,278.49454000000003L314.1343999999999,274.20454L318.2043999999999,273.21453L330.0843999999999,265.29454000000004L338.0043999999999,265.07454L343.0643999999999,256.27454L352.9643999999999,251.10454000000001L362.3143999999999,247.36454L367.2643999999999,249.12454L370.5643999999999,272.44454L364.9543999999999,276.95454L359.2343999999999,276.40453L345.37439999999987,281.46453L337.3443999999999,281.02454L334.5943999999999,288.94454L334.5943999999999,288.94454ZM334.5944,288.94453999999996L334.5944,288.94453999999996L334.5944,288.94453999999996L334.5944,288.94453999999996Z"
        fillRule="evenodd"
        strokeWidth="1"
        data-hasqtip="31"
        strokeDasharray="0"
        onClick={handleClick}
      ></path>
      <path
        id="ritchie"
        className="county blue-county"
        strokeLinejoin="round"
        cursor="pointer"
        fill="transparent"
        stroke="black"
        d="M334.4844,288.94454L337.3444,281.02454L345.3744,281.46453L359.2344,276.40453L364.9544,276.95454L370.56440000000003,272.44454L377.60440000000006,274.75454L382.3344000000001,264.85454000000004L389.92440000000005,270.46453L389.15440000000007,283.77454L385.1944000000001,288.06454L401.03440000000006,320.84453L397.5144000000001,326.23453L390.8044000000001,328.10453L385.6344000000001,333.49453L377.16440000000006,335.69453L371.44440000000003,340.86453L366.60440000000006,340.86453L357.1444000000001,339.65453L353.29440000000005,334.15453L346.47440000000006,336.57453000000004L343.72440000000006,334.37453000000005L332.72440000000006,335.69453000000004L331.5144000000001,323.70453000000003L326.8944000000001,316.11453000000006L320.5144000000001,312.1545300000001L325.35440000000006,305.55453000000006L324.80440000000004,302.0345300000001L330.0844,290.5945300000001L334.5944,288.9445300000001L334.5944,288.9445300000001L334.5944,288.9445300000001L334.5944,288.9445300000001L334.5944,288.9445300000001Z"
        fillRule="evenodd"
        strokeWidth="1"
        data-hasqtip="32"
        strokeDasharray="0"
        onClick={handleClick}
      ></path>
      <path
        id="wood"
        className="county green-county"
        strokeLinejoin="round"
        cursor="pointer"
        fill="transparent"
        stroke="black"
        d="M314.1344,274.20454L315.23440000000005,278.49454000000003L321.3944000000001,279.26454L321.3944000000001,282.89454L331.1844000000001,284.10454L334.4844000000001,288.94453999999996L334.5944000000001,288.94453999999996L334.5944000000001,288.94453999999996L334.5944000000001,288.94453999999996L334.5944000000001,288.94453999999996L334.5944000000001,288.94453999999996L334.5944000000001,288.94453999999996L334.5944000000001,288.94453999999996L330.08440000000013,290.59453999999994L324.80440000000016,302.03453999999994L325.35440000000017,305.5545399999999L310.61440000000016,314.24452999999994L305.55440000000016,315.45453999999995L281.0244000000001,337.2345399999999L266.50440000000015,329.4245399999999L255.17440000000013,323.1545299999999L256.05440000000016,318.8645399999999L253.96440000000015,306.10453999999993L256.49440000000016,304.2345399999999L258.80440000000016,299.0645399999999L264.19440000000014,296.7545399999999L263.31440000000015,291.0345399999999L267.49440000000016,287.0745399999999L283.88440000000014,287.1845399999999L285.0944000000001,274.6445399999999L300.9344000000001,260.5645399999999L308.6344000000001,264.85453999999993L310.28440000000006,271.45453999999995Z"
        fillRule="evenodd"
        strokeWidth="1"
        data-hasqtip="33"
        strokeDasharray="0"
        onClick={handleClick}
      ></path>
      <path
        id="wayne"
        className="county green-county"
        strokeLinejoin="round"
        cursor="pointer"
        fill="transparent"
        stroke="black"
        d="M164.7544,552.72454L149.0244,568.67453L147.26440000000002,570.10454L146.4944,564.16454L133.6244,554.37454L134.39440000000002,551.9545400000001L138.57440000000003,548.98454L136.04440000000002,541.28454L131.20440000000002,540.51454L126.69440000000002,527.31454L121.08440000000002,519.39454L113.05440000000002,512.90454L111.95440000000002,507.29454L117.12440000000002,506.41454L119.43440000000002,497.28454L118.55440000000003,491.12453999999997L123.28440000000003,487.82453999999996L123.94440000000003,478.14453999999995L119.87440000000004,471.5445399999999L120.86440000000003,456.3645399999999L124.27440000000003,459.77453999999994L134.28440000000003,458.6745399999999L159.80440000000004,480.34453999999994L167.17440000000005,475.94453999999996L170.47440000000006,480.67454L165.85440000000006,482.43453999999997L166.62440000000007,493.43453999999997L172.12440000000007,495.74454L170.03440000000006,500.36454L168.93440000000007,513.12454L176.30440000000007,526.43454L183.01440000000008,531.4945399999999L181.2544000000001,536.9945399999999L174.8744000000001,541.3945399999999Z"
        fillRule="evenodd"
        strokeWidth="1"
        data-hasqtip="34"
        strokeDasharray="0"
        onClick={handleClick}
      ></path>
      <path
        id="tucker"
        className="county green-county"
        strokeLinejoin="round"
        cursor="pointer"
        fill="transparent"
        stroke="black"
        d="M555.0344,318.42454L553.2744,316.11453L557.2344,295.43453L576.1544,286.96452999999997L604.3144,297.63453L607.5044,301.81453L607.5044,301.81453L610.6944000000001,305.00453L622.2444,301.92453L631.4844,297.41453L638.4144,302.25453L631.9244,310.83453L632.0344,316.55453L628.4044,323.15453L637.4244,325.68453L635.6644,334.26453L630.8244,346.80453L628.5144,347.57453L604.8644,345.81453L561.4144,334.04453L562.9544,326.12453Z"
        fillRule="evenodd"
        strokeWidth="1"
        data-hasqtip="35"
        strokeDasharray="0"
        onClick={handleClick}
      ></path>
      <path
        id="wirt"
        className="county grey-county"
        strokeLinejoin="round"
        cursor="pointer"
        fill="transparent"
        stroke="black"
        d="M346.4744,336.57454L329.2044,355.38454L328.3244,359.67454000000004L317.98440000000005,363.52454000000006L306.87440000000004,358.4645300000001L301.7044,354.2845300000001L293.2344,359.01454000000007L285.9744,349.00453000000005L288.7244,341.30453000000006L281.0244,337.23453000000006L305.5544,315.4545300000001L310.6144,314.2445300000001L325.3544,305.5545300000001L320.5144,312.15453000000014L326.8944,316.1145300000001L331.5144,323.7045300000001L332.7244,335.6945300000001L343.7244,334.3745300000001Z"
        fillRule="evenodd"
        strokeWidth="1"
        data-hasqtip="36"
        strokeDasharray="0"
        onClick={handleClick}
      ></path>
      <path
        id="calhoun"
        className="county green-county"
        strokeLinejoin="round"
        cursor="pointer"
        fill="transparent"
        stroke="black"
        d="M328.3244,359.67454L329.2044,355.38453999999996L346.4744,336.57453999999996L353.2944,334.15453999999994L357.1444,339.65453999999994L366.6044,340.8645399999999L371.2244,350.5445399999999L369.6844,358.1345399999999L371.33439999999996,373.5345399999999L369.90439999999995,378.37453999999985L362.97439999999995,384.09452999999985L366.9343999999999,390.80453999999986L372.2143999999999,393.33453999999983L374.1943999999999,399.27453999999983L371.8843999999999,402.3545399999998L366.8243999999999,409.2845399999998L360.55439999999993,417.75453999999985L358.6843999999999,420.39453999999984L354.9443999999999,414.89453999999984L346.91439999999994,413.9045399999998L345.3743999999999,396.63453999999984L337.67439999999993,383.1045399999999L337.23439999999994,373.97452999999985L333.27439999999996,372.1045399999999L334.48439999999994,366.6045399999999Z"
        fillRule="evenodd"
        strokeWidth="1"
        data-hasqtip="37"
        strokeDasharray="0"
        onClick={handleClick}
      ></path>
      <path
        id="taylor"
        className="county green-county"
        strokeLinejoin="round"
        cursor="pointer"
        fill="transparent"
        stroke="black"
        d="M536.5544,251.21453L537.7644,251.76453999999998L543.4844,254.51453999999998L543.7044000000001,281.68453999999997L543.7044000000001,281.68453999999997L537.2144000000001,282.23452999999995L533.4744000000001,288.06453999999997L523.9044,292.35454L504.2144,294.44453999999996L501.5744,293.67454L495.9644,286.52454L496.5144,263.42454L508.17440000000005,261.77454L513.6744000000001,264.63454L523.2444000000002,261.55454000000003L525.4444000000002,258.25454Z"
        fillRule="evenodd"
        strokeWidth="1"
        data-hasqtip="38"
        strokeDasharray="0"
        onClick={handleClick}
      ></path>
      <path
        id="randolph"
        className="county green-county"
        strokeLinejoin="round"
        cursor="pointer"
        fill="transparent"
        stroke="black"
        d="M628.5144,347.57454L629.8344000000001,348.78454L629.7244000000001,349.00454L625.9844,356.37454L613.2244000000001,354.83454L615.2044000000001,360.99454000000003L609.1544000000001,363.52454L604.6444000000001,362.09454L600.5744000000001,372.65454L605.5244000000001,380.68453999999997L605.3044000000001,384.75453999999996L597.4944000000002,397.62453999999997L591.8844000000001,403.67454L592.5444000000001,408.07453999999996L587.3744000000002,408.40453999999994L581.8744000000002,403.2345399999999L579.2344000000002,408.40453999999994L573.0744000000002,404.33453999999995L569.6644000000002,405.5445399999999L570.1044000000003,399.0545399999999L562.8444000000003,394.21453999999994L555.5844000000003,414.12453999999997L550.5244000000004,431.61454L524.5644000000003,450.20453999999995L510.8144000000003,447.34453999999994L490.6844000000003,464.72453999999993L500.1444000000003,437.22453999999993L484.7444000000003,403.34453999999994L491.4544000000003,393.5545399999999L508.8344000000003,393.0045399999999L513.0144000000003,373.97453999999993L511.25440000000026,362.7545399999999L514.8844000000003,352.6345399999999L544.3644000000003,347.0245399999999L549.2044000000003,327.11453999999986L555.0344000000003,318.42453999999987L562.9544000000003,326.12453999999985L561.4144000000003,334.04453999999987L604.8644000000004,345.81453999999985Z"
        fillRule="evenodd"
        strokeWidth="1"
        data-hasqtip="39"
        strokeDasharray="0"
        onClick={handleClick}
      ></path>
      <path
        id="putnam"
        className="county green-county"
        strokeLinejoin="round"
        cursor="pointer"
        fill="transparent"
        stroke="black"
        d="M206.7744,467.03454L206.33440000000002,461.20454L205.7844,447.01454L204.5744,420.28454L221.7344,410.60454L250.5544,406.09452999999996L254.5144,405.54452999999995L262.4344,417.09452999999996L253.85439999999997,424.13453L253.19439999999997,437.55453L257.59439999999995,449.10453L240.32439999999994,456.36453L229.98439999999994,462.41453L227.45439999999994,477.04454000000004L215.35439999999994,488.26454000000007L206.33439999999993,483.86453000000006Z"
        fillRule="evenodd"
        strokeWidth="1"
        data-hasqtip="40"
        strokeDasharray="0"
        onClick={handleClick}
      ></path>
      <path
        id="raleigh"
        className="county green-county"
        strokeLinejoin="round"
        cursor="pointer"
        fill="transparent"
        stroke="black"
        d="M356.7044,625.21454L350.2144,623.3445300000001L340.0944,628.0745300000001L339.9844,634.4545300000001L336.3544,640.8345300000001L323.3744,633.5745300000001L320.6244,623.3445300000001L303.7944,592.9845300000001L298.07439999999997,585.6145300000001L290.15439999999995,584.51453L289.71439999999996,579.01453L282.78439999999995,574.39453L281.2443999999999,557.01453L286.41439999999994,548.43453L291.47439999999995,545.02453L299.5043999999999,545.24453L302.36439999999993,549.2045300000001L311.4943999999999,548.9845300000001L316.7743999999999,547.4445300000001L324.8043999999999,554.0445300000001L325.0243999999999,565.0445300000001L360.2243999999999,567.7945300000001L362.75439999999986,575.8245300000001L375.2943999999999,576.37453L380.57439999999986,579.12453L388.6043999999998,589.5745300000001L383.9843999999998,594.5245300000001L387.9443999999998,597.0545300000001L390.5843999999998,606.8445300000001L380.2443999999998,599.9145300000001L360.8843999999998,614.9845300000002L361.6543999999998,620.7045300000002Z"
        fillRule="evenodd"
        strokeWidth="1"
        data-hasqtip="41"
        strokeDasharray="0"
        onClick={handleClick}
      ></path>
      <path
        id="hancock"
        className="county blue-county"
        strokeLinejoin="round"
        cursor="pointer"
        fill="transparent"
        stroke="black"
        d="M428.5344,63.224535L433.8144,47.934535000000004L428.7544,34.95453500000001L422.59439999999995,25.714535000000005L428.86439999999993,18.124535000000005L435.35439999999994,18.894535000000005L445.2543999999999,14.274535000000004L445.6943999999999,62.23453500000001L437.11439999999993,62.23453500000001Z"
        fillRule="evenodd"
        strokeWidth="1"
        data-hasqtip="42"
        strokeDasharray="0"
        onClick={handleClick}
      ></path>
      <path
        id="mineral"
        className="county green-county"
        strokeLinejoin="round"
        cursor="pointer"
        fill="transparent"
        stroke="black"
        d="M640.6144,274.53453L642.8144000000001,269.03453L649.4144000000001,267.27454L651.8344000000001,262.21453L656.8944,262.43454L657.5544,256.60453L662.6143999999999,256.05453L666.6844,244.17453L671.6344,243.62453L689.2344,250.77453L688.7944,246.37453L695.0644,241.75453L706.9444,225.25453L708.7044,220.85452999999998L715.8543999999999,213.92452999999998L722.8943999999999,215.57452999999998L715.9644,218.10452999999998L719.5944,222.28453L735.1043999999999,230.97454L724.2144,245.71453L718.3843999999999,249.01453999999998L712.0043999999999,263.31453999999997L706.0643999999999,272.55454L700.3443999999998,273.87453999999997L694.5143999999998,283.33453999999995L686.3743999999998,291.69453999999996L661.9543999999999,277.28452999999996Z"
        fillRule="evenodd"
        strokeWidth="1"
        data-hasqtip="43"
        strokeDasharray="0"
        onClick={handleClick}
      ></path>
      <path
        id="pocahontas"
        className="county green-county"
        strokeLinejoin="round"
        cursor="pointer"
        fill="transparent"
        stroke="black"
        d="M584.0744,422.92454L576.4843999999999,446.46452999999997L578.1343999999999,455.15452999999997L569.9943999999999,470.88453L559.5443999999999,480.78452999999996L561.8543999999998,488.59452999999996L556.3543999999998,491.78452999999996L546.0143999999998,503.22452999999996L538.5343999999998,515.54453L541.6143999999998,520.49453L536.4443999999999,529.29453L513.1243999999998,531.05453L503.3343999999998,535.12453L488.2643999999998,533.14454L472.5343999999998,519.72453L472.86439999999976,497.39453L473.9643999999998,473.41452999999996L477.3743999999998,475.39453L490.6843999999998,464.72452999999996L510.8143999999998,447.34452999999996L524.5643999999998,450.20453L550.5243999999998,431.61453L555.5843999999997,414.12454L562.8443999999997,394.21453L570.1043999999997,399.05453L569.6643999999997,405.54453L573.0743999999996,404.33453000000003L579.2343999999996,408.40453L581.8743999999996,403.23453L587.3743999999996,408.40453L588.6943999999996,416.65453Z"
        fillRule="evenodd"
        strokeWidth="1"
        data-hasqtip="44"
        strokeDasharray="0"
        onClick={handleClick}
      ></path>
      <path
        id="braxton"
        className="county green-county"
        strokeLinejoin="round"
        cursor="pointer"
        fill="transparent"
        stroke="black"
        d="M456.9144,394.76454L448.9944,413.46453L426.7744,437.44454L413.1344,436.34453L411.04440000000005,437.66453L405.54440000000005,431.28453L390.47440000000006,441.40453L388.8244000000001,435.46453L384.7544000000001,433.81454L383.4344000000001,426.99454000000003L376.5044000000001,424.13453000000004L375.6244000000001,417.75453000000005L366.8244000000001,409.28453L371.8844000000001,402.35453L374.1944000000001,399.27453L418.52440000000007,366.93453L423.47440000000006,364.07453L427.98440000000005,365.72452999999996L433.48440000000005,361.76453L437.00440000000003,370.89453L446.5744,370.12453L454.2744,376.72453L452.4044,382.55453L458.56440000000003,387.06453Z"
        fillRule="evenodd"
        strokeWidth="1"
        data-hasqtip="45"
        strokeDasharray="0"
        onClick={handleClick}
      ></path>
      <path
        id="jefferson"
        className="county green-county"
        strokeLinejoin="round"
        cursor="pointer"
        fill="transparent"
        stroke="black"
        d="M864.2444,235.48454L873.3744,235.59453000000002L868.7544,238.23454L871.5044,240.98454L868.0944000000001,246.48454L875.9044,249.01454L878.8744,255.50454000000002L876.3444000000001,258.03454L876.2344,267.05454L881.9544000000001,269.36454L877.7744000000001,274.86454L874.4744000000002,286.63453999999996L870.5144000000001,293.89453999999995L866.3344000000002,307.75453999999996L833.5544000000002,282.34453999999994L840.1544000000002,271.01453999999995L843.2344000000003,261.55454L848.7344000000003,258.47452999999996L861.2744000000002,244.94452999999996Z"
        fillRule="evenodd"
        strokeWidth="1"
        data-hasqtip="46"
        strokeDasharray="0"
        onClick={handleClick}
      ></path>
      <path
        id="marion"
        className="county green-county"
        strokeLinejoin="round"
        cursor="pointer"
        fill="transparent"
        stroke="black"
        d="M465.3844,214.80454L472.86440000000005,219.86454L502.8944,219.86454L532.0444,249.12453L536.5544,251.21453L525.4444,258.25454L523.2443999999999,261.55454000000003L513.6743999999999,264.63454L508.1743999999999,261.77454L496.51439999999985,263.42454L481.5543999999999,255.39453999999998L450.31439999999986,248.46452999999997L453.83439999999985,245.16453999999996L449.65439999999984,229.76453999999995L452.62439999999987,222.94453999999996L456.9143999999999,223.16453999999996L459.5543999999999,214.47452999999996Z"
        fillRule="evenodd"
        strokeWidth="1"
        data-hasqtip="47"
        strokeDasharray="0"
        onClick={handleClick}
      ></path>
      <path
        id="monroe"
        className="county green-county"
        strokeLinejoin="round"
        cursor="pointer"
        fill="transparent"
        stroke="black"
        d="M483.7544,604.20453L488.3744,613.33453L495.8544,616.96453L489.8044,623.45453L478.8044,629.72453L478.58439999999996,635.33453L486.17439999999993,635.8845299999999L483.42439999999993,640.9445299999999L455.48439999999994,658.2145399999998L449.7643999999999,646.4445299999999L443.2743999999999,648.0945299999998L418.8543999999999,664.0445299999999L408.5143999999999,668.5545299999999L406.3143999999999,664.0445299999999L394.4343999999999,657.3345299999999L404.0043999999999,638.5245299999999L411.92439999999993,625.4345299999999L425.78439999999995,599.9145299999999L425.34439999999995,596.5045299999999L450.3144,604.5345299999999L459.2244,605.9645299999999L468.1344,599.2545299999998L469.56440000000003,604.0945299999998Z"
        fillRule="evenodd"
        strokeWidth="1"
        data-hasqtip="48"
        strokeDasharray="0"
        onClick={handleClick}
      ></path>
      <path
        id="marshall"
        className="county green-county"
        strokeLinejoin="round"
        cursor="pointer"
        fill="transparent"
        stroke="black"
        d="M446.1344,198.08454L424.79440000000005,198.19453000000001L397.5144,198.41453L391.9044,189.94453000000001L398.7244,182.79453L399.3844,172.45453L403.7844,169.70453L401.1444,161.34453000000002L403.3444,158.48453L408.8444,160.68453L408.4044,151.66452999999998L411.9244,148.25453L412.8044,135.71453L419.95439999999996,136.37453L445.91439999999994,139.01452999999998L446.02439999999996,164.09452999999996Z"
        fillRule="evenodd"
        strokeWidth="1"
        data-hasqtip="49"
        strokeDasharray="0"
        onClick={handleClick}
      ></path>
      <path
        id="jackson"
        className="county green-county"
        strokeLinejoin="round"
        cursor="pointer"
        fill="transparent"
        stroke="black"
        d="M229.6544,366.38454L237.4644,364.07454L239.7744,356.37454L244.5044,352.96453L250.7744,357.69454L253.5244,355.60454000000004L249.5644,349.22453L252.42440000000002,338.99454000000003L246.3744,332.61453L244.83440000000002,326.23453L250.55440000000002,326.56453L255.17440000000002,323.15452999999997L266.50440000000003,329.42452999999995L281.0244,337.23452999999995L288.7244,341.30452999999994L285.9744,349.00452999999993L293.2344,359.01453999999995L288.8344,363.52453999999994L290.1544,377.60453999999993L288.8344,392.89453999999995L286.0844,408.07453999999996L289.8244,420.06453999999997L280.9144,427.10452999999995L272.3344,431.61452999999995L262.43440000000004,417.09452999999996L254.51440000000005,405.54452999999995L250.55440000000004,406.09452999999996L244.17440000000005,399.27453999999994L247.69440000000006,395.64453999999995L230.53440000000006,369.46452999999997Z"
        fillRule="evenodd"
        strokeWidth="1"
        data-hasqtip="50"
        strokeDasharray="0"
        onClick={handleClick}
      ></path>
      <path
        id="morgan"
        className="county green-county"
        strokeLinejoin="round"
        cursor="pointer"
        fill="transparent"
        stroke="black"
        d="M764.4744,233.94453L770.7443999999999,225.25453L767.5543999999999,218.87453L775.1443999999999,218.87453L770.6343999999999,212.16452999999998L777.8943999999999,215.24453999999997L777.4543999999999,211.06452999999996L784.6043999999998,209.30452999999997L795.1643999999998,212.60452999999998L796.9243999999998,208.31453L807.8143999999998,196.87453L819.9143999999998,199.29452999999998L824.4243999999998,201.82452999999998L833.0043999999998,211.28453L822.0043999999998,219.09453L815.0743999999999,217.00453L810.3443999999998,230.97453L806.4943999999998,247.80453L802.4243999999998,257.92453L796.9243999999998,253.52453L783.6143999999998,243.51453L769.5343999999998,237.24453Z"
        fillRule="evenodd"
        strokeWidth="1"
        data-hasqtip="51"
        strokeDasharray="0"
        onClick={handleClick}
      ></path>
      <path
        id="upshur"
        className="county green-county"
        strokeLinejoin="round"
        cursor="pointer"
        fill="transparent"
        stroke="black"
        d="M467.0344,396.96453L464.3944,388.82454L467.80440000000004,367.48454000000004L478.47440000000006,350.65454000000005L475.8344000000001,343.0645400000001L478.36440000000005,339.65454000000005L481.00440000000003,321.5045400000001L489.0344,322.0545400000001L492.3344,319.6345400000001L501.68440000000004,324.58454000000006L507.9544,334.48454000000004L519.2844,334.59454000000005L519.8344,346.91454000000004L514.8843999999999,352.6345400000001L511.2543999999999,362.7545400000001L513.0143999999999,373.9745300000001L508.8343999999999,393.0045400000001L491.4543999999999,393.5545400000001L484.7443999999999,403.3445300000001L478.80439999999993,405.54453000000007L473.30439999999993,396.3045400000001Z"
        fillRule="evenodd"
        strokeWidth="1"
        data-hasqtip="52"
        strokeDasharray="0"
        onClick={handleClick}
      ></path>
      <path
        id="logan"
        className="county green-county"
        strokeLinejoin="round"
        cursor="pointer"
        fill="transparent"
        stroke="black"
        d="M244.0644,610.36454L233.2844,606.29453L227.5644,609.70453L223.8244,605.85453L215.9044,608.60453L213.92440000000002,613.55453L206.22440000000003,601.78453L199.62440000000004,601.67453L195.99440000000004,591.88453L196.21440000000004,581.65453L192.03440000000003,579.89454L189.94440000000003,573.95453L195.22440000000003,571.09453L193.35440000000003,561.96453L187.30440000000002,559.32453L182.13440000000003,548.87454L183.12440000000004,546.78453L206.44440000000003,539.08453L224.15440000000004,537.10453L216.67440000000005,543.81453L221.18440000000004,547.77454L227.23440000000005,547.11454L235.37440000000004,552.61454L247.25440000000003,555.14454L251.43440000000004,565.26454L247.69440000000003,568.67453L253.30440000000004,573.62454L257.15440000000007,580.66453L267.27440000000007,575.71454L275.30440000000004,584.9545300000001L261.55440000000004,587.7045300000001L250.33440000000004,592.1045300000001L260.23440000000005,602.22454Z"
        fillRule="evenodd"
        strokeWidth="1"
        data-hasqtip="53"
        strokeDasharray="0"
        onClick={handleClick}
      ></path>
      <path
        id="boone"
        className="county green-county"
        strokeLinejoin="round"
        cursor="pointer"
        fill="transparent"
        stroke="black"
        d="M290.1544,584.51454L280.25440000000003,590.01454L275.30440000000004,584.95453L267.27440000000007,575.7145399999999L257.15440000000007,580.6645299999999L253.30440000000007,573.6245399999999L247.69440000000006,568.6745299999999L251.43440000000007,565.2645399999999L247.25440000000006,555.1445399999999L235.37440000000007,552.6145399999999L227.23440000000005,547.1145399999999L221.18440000000004,547.7745399999999L216.67440000000005,543.8145299999999L224.15440000000004,537.1045299999998L228.44440000000003,536.3345299999999L217.99440000000004,532.0445299999999L221.07440000000005,518.4045299999999L225.25440000000006,511.6945399999999L232.84440000000006,514.7745399999999L231.74440000000007,508.6145299999999L237.35440000000008,507.6245399999999L240.2144000000001,500.3645299999999L251.1044000000001,496.95452999999986L255.3944000000001,502.78452999999985L257.2644000000001,498.16452999999984L270.1344000000001,498.49453999999986L269.3644000000001,505.53452999999985L276.6244000000001,507.73452999999984L281.7944000000001,515.2145399999998L290.26440000000014,520.1645299999998L286.74440000000016,527.4245299999998L294.2244000000002,529.2945299999998L298.9544000000002,537.3245399999997L299.5044000000002,545.2445399999997L291.47440000000023,545.0245399999997L286.4144000000002,548.4345399999996L281.2444000000002,557.0145399999997L282.78440000000023,574.3945399999997L289.71440000000024,579.0145399999997Z"
        fillRule="evenodd"
        strokeWidth="1"
        data-hasqtip="54"
        strokeDasharray="0"
        onClick={handleClick}
      ></path>
      <text
        className="county-label"
        x="425"
        y="216"
        textAnchor="middle"
        fontFamily="Roboto"
        stroke="none"
        fill="#000000"
        fontSize="12px"
        data-hasqtip="55"
      >
        <tspan dy="5.5">Wetzel</tspan>
      </text>
      <text
        className="county-label"
        x="405"
        y="482"
        textAnchor="middle"
        fontFamily="Roboto"
        stroke="none"
        fill="#000000"
        fontSize="12px"
        data-hasqtip="56"
      >
        <tspan dy="5.5">Nicholas</tspan>
      </text>
      <text
        className="county-label"
        x="360"
        y="450"
        textAnchor="middle"
        fontFamily="Roboto"
        stroke="none"
        fill="#000000"
        fontSize="12px"
        data-hasqtip="57"
      >
        <tspan dy="5.5">Clay</tspan>
      </text>
      <text
        className="county-label"
        x="834"
        y="240"
        textAnchor="middle"
        fontFamily="Roboto"
        stroke="none"
        fill="#000000"
        fontSize="12px"
        data-hasqtip="58"
      >
        <tspan dy="5.5">Berkeley</tspan>
      </text>
      <text
        className="county-label"
        x="390"
        y="246"
        textAnchor="middle"
        fontFamily="Roboto"
        stroke="none"
        fill="#000000"
        fontSize="12px"
        data-hasqtip="59"
      >
        <tspan dy="5.5">Tyler</tspan>
      </text>
      <text
        className="county-label"
        x="355"
        y="534"
        textAnchor="middle"
        fontFamily="Roboto"
        stroke="none"
        fill="#000000"
        fontSize="12px"
        data-hasqtip="60"
      >
        <tspan dy="5.5">Fayette</tspan>
      </text>
      <text
        className="county-label"
        x="292"
        y="471"
        textAnchor="middle"
        fontFamily="Roboto"
        stroke="none"
        fill="#000000"
        fontSize="12px"
        data-hasqtip="61"
      >
        <tspan dy="5.5">Kanawha</tspan>
      </text>
      <text
        className="county-label"
        x="484"
        y="84"
        textAnchor="middle"
        fontFamily="Roboto"
        stroke="none"
        fill="#000000"
        fontSize="12px"
        data-hasqtip="62"
      >
        <tspan dy="5.5">Brooke</tspan>
      </text>
      <text
        className="county-label"
        x="477"
        y="124"
        textAnchor="middle"
        fontFamily="Roboto"
        stroke="none"
        fill="#000000"
        fontSize="12px"
        data-hasqtip="63"
      >
        <tspan dy="5.5">Ohio</tspan>
      </text>
      <text
        className="county-label"
        x="202"
        y="505"
        textAnchor="middle"
        fontFamily="Roboto"
        stroke="none"
        fill="#000000"
        fontSize="12px"
        data-hasqtip="64"
      >
        <tspan dy="5.5">Lincoln</tspan>
      </text>
      <text
        className="county-label"
        x="514"
        y="208"
        textAnchor="middle"
        fontFamily="Roboto"
        stroke="none"
        fill="#000000"
        fontSize="12px"
        data-hasqtip="65"
      >
        <tspan dy="5.5">Monongalia</tspan>
      </text>
      <text
        className="county-label"
        x="468"
        y="281"
        textAnchor="middle"
        fontFamily="Roboto"
        stroke="none"
        fill="#000000"
        fontSize="12px"
        data-hasqtip="66"
      >
        <tspan dy="5.5">Harrison</tspan>
      </text>
      <text
        className="county-label"
        x="744"
        y="272"
        textAnchor="middle"
        fontFamily="Roboto"
        stroke="none"
        fill="#000000"
        fontSize="12px"
        data-hasqtip="67"
      >
        <tspan dy="5.5">Hampshire</tspan>
      </text>
      <text
        className="county-label"
        x="631"
        y="405"
        textAnchor="middle"
        fontFamily="Roboto"
        stroke="none"
        fill="#000000"
        fontSize="12px"
        data-hasqtip="68"
      >
        <tspan dy="5.5">Pendleton</tspan>
      </text>
      <text
        className="county-label"
        x="653"
        y="313"
        textAnchor="middle"
        fontFamily="Roboto"
        stroke="none"
        fill="#000000"
        fontSize="12px"
        data-hasqtip="69"
      >
        <tspan dy="5.5">Grant</tspan>
      </text>
      <text
        className="county-label"
        x="709"
        y="334"
        textAnchor="middle"
        fontFamily="Roboto"
        stroke="none"
        fill="#000000"
        fontSize="12px"
        data-hasqtip="70"
      >
        <tspan dy="5.5">Hardy</tspan>
      </text>
      <text
        className="county-label"
        x="391"
        y="615"
        textAnchor="middle"
        fontFamily="Roboto"
        stroke="none"
        fill="#000000"
        fontSize="12px"
        data-hasqtip="71"
      >
        <tspan dy="5.5">Summers</tspan>
      </text>
      <text
        className="county-label"
        x="178"
        y="459"
        textAnchor="middle"
        fontFamily="Roboto"
        stroke="none"
        fill="#000000"
        fontSize="12px"
        data-hasqtip="72"
      >
        <tspan dy="5.5">Cabell</tspan>
      </text>
      <text
        className="county-label"
        x="213"
        y="388"
        textAnchor="middle"
        fontFamily="Roboto"
        stroke="none"
        fill="#000000"
        fontSize="12px"
        data-hasqtip="73"
      >
        <tspan dy="5.5">Mason</tspan>
      </text>
      <text
        className="county-label"
        x="463"
        y="445"
        textAnchor="middle"
        fontFamily="Roboto"
        stroke="none"
        fill="#000000"
        fontSize="12px"
        data-hasqtip="74"
      >
        <tspan dy="5.5">Webster</tspan>
      </text>
      <text
        className="county-label"
        x="458"
        y="555"
        textAnchor="middle"
        fontFamily="Roboto"
        stroke="none"
        fill="#000000"
        fontSize="12px"
        data-hasqtip="75"
      >
        <tspan dy="5.5">Greenbrier</tspan>
      </text>
      <text
        className="county-label"
        x="448"
        y="340"
        textAnchor="middle"
        fontFamily="Roboto"
        stroke="none"
        fill="#000000"
        fontSize="12px"
        data-hasqtip="76"
      >
        <tspan dy="5.5">Lewis</tspan>
      </text>
      <text
        className="county-label"
        x="577"
        y="249"
        textAnchor="middle"
        fontFamily="Roboto"
        stroke="none"
        fill="#000000"
        fontSize="12px"
        data-hasqtip="77"
      >
        <tspan dy="5.5">Preston</tspan>
      </text>
      <text
        className="county-label"
        x="413"
        y="294"
        textAnchor="middle"
        fontFamily="Roboto"
        stroke="none"
        fill="#000000"
        fontSize="12px"
        data-hasqtip="78"
      >
        <tspan dy="-3.5">Dodd-</tspan>
        <tspan dy="18" x="413">
          ridge
        </tspan>
      </text>
      <text
        className="county-label"
        x="397"
        y="353"
        textAnchor="middle"
        fontFamily="Roboto"
        stroke="none"
        fill="#000000"
        fontSize="12px"
        data-hasqtip="79"
      >
        <tspan dy="5.5">Gilmer</tspan>
      </text>
      <text
        className="county-label"
        x="315"
        y="399"
        textAnchor="middle"
        fontFamily="Roboto"
        stroke="none"
        fill="#000000"
        fontSize="12px"
        data-hasqtip="80"
      >
        <tspan dy="5.5">Roane</tspan>
      </text>
      <text
        className="county-label"
        x="525"
        y="310"
        textAnchor="middle"
        fontFamily="Roboto"
        stroke="none"
        fill="#000000"
        fontSize="12px"
        data-hasqtip="81"
      >
        <tspan dy="5.5">Barbour</tspan>
      </text>
      <text
        className="county-label"
        x="358"
        y="662"
        textAnchor="middle"
        fontFamily="Roboto"
        stroke="none"
        fill="#000000"
        fontSize="12px"
        data-hasqtip="82"
      >
        <tspan dy="5.5">Mercer</tspan>
      </text>
      <text
        className="county-label"
        x="272"
        y="666"
        textAnchor="middle"
        fontFamily="Roboto"
        stroke="none"
        fill="#000000"
        fontSize="12px"
        data-hasqtip="83"
      >
        <tspan dy="5.5">McDowell</tspan>
      </text>
      <text
        className="county-label"
        x="281"
        y="618"
        textAnchor="middle"
        fontFamily="Roboto"
        stroke="none"
        fill="#000000"
        fontSize="12px"
        data-hasqtip="84"
      >
        <tspan dy="5.5">Wyoming</tspan>
      </text>
      <text
        className="county-label"
        x="149"
        y="621"
        textAnchor="middle"
        fontFamily="Roboto"
        stroke="none"
        fill="#000000"
        fontSize="12px"
        data-hasqtip="85"
      >
        <tspan dy="5.5">Mingo</tspan>
      </text>
      <text
        className="county-label"
        x="306"
        y="241"
        textAnchor="middle"
        fontFamily="Roboto"
        stroke="none"
        fill="#000000"
        fontSize="12px"
        data-hasqtip="86"
      >
        <tspan dy="5.5">Pleasants</tspan>
      </text>
      <text
        className="county-label"
        x="360"
        y="307"
        textAnchor="middle"
        fontFamily="Roboto"
        stroke="none"
        fill="#000000"
        fontSize="12px"
        data-hasqtip="87"
      >
        <tspan dy="5.5">Ritchie</tspan>
      </text>
      <text
        className="county-label"
        x="290"
        y="300"
        textAnchor="middle"
        fontFamily="Roboto"
        stroke="none"
        fill="#000000"
        fontSize="12px"
        data-hasqtip="88"
      >
        <tspan dy="5.5">Wood</tspan>
      </text>
      <text
        className="county-label"
        x="142"
        y="509"
        textAnchor="middle"
        fontFamily="Roboto"
        stroke="none"
        fill="#000000"
        fontSize="12px"
        data-hasqtip="89"
      >
        <tspan dy="5.5">Wayne</tspan>
      </text>
      <text
        className="county-label"
        x="595"
        y="318"
        textAnchor="middle"
        fontFamily="Roboto"
        stroke="none"
        fill="#000000"
        fontSize="12px"
        data-hasqtip="90"
      >
        <tspan dy="5.5">Tucker</tspan>
      </text>
      <text
        className="county-label"
        x="312"
        y="337"
        textAnchor="middle"
        fontFamily="Roboto"
        stroke="none"
        fill="#000000"
        fontSize="12px"
        data-hasqtip="91"
      >
        <tspan dy="5.5">Wirt</tspan>
      </text>
      <text
        className="county-label"
        x="347"
        y="360"
        textAnchor="middle"
        fontFamily="Roboto"
        stroke="none"
        fill="#000000"
        fontSize="12px"
        data-hasqtip="92"
      >
        <tspan dy="-2">Cal-</tspan>
        <tspan dy="16" x="352">
          houn
        </tspan>
      </text>
      <text
        className="county-label"
        x="518"
        y="275"
        textAnchor="middle"
        fontFamily="Roboto"
        stroke="none"
        fill="#000000"
        fontSize="12px"
        data-hasqtip="93"
      >
        <tspan dy="5.5">Taylor</tspan>
      </text>
      <text
        className="county-label"
        x="558"
        y="371"
        textAnchor="middle"
        fontFamily="Roboto"
        stroke="none"
        fill="#000000"
        fontSize="12px"
        data-hasqtip="94"
      >
        <tspan dy="5.5">Randolph</tspan>
      </text>
      <text
        className="county-label"
        x="230"
        y="436"
        textAnchor="middle"
        fontFamily="Roboto"
        stroke="none"
        fill="#000000"
        fontSize="12px"
        data-hasqtip="95"
      >
        <tspan dy="5.5">Putnam</tspan>
      </text>
      <text
        className="county-label"
        x="337"
        y="591"
        textAnchor="middle"
        fontFamily="Roboto"
        stroke="none"
        fill="#000000"
        fontSize="12px"
        data-hasqtip="96"
      >
        <tspan dy="5.5">Raleigh</tspan>
      </text>
      <text
        className="county-label"
        x="489"
        y="38"
        textAnchor="middle"
        fontFamily="Roboto"
        stroke="none"
        fill="#000000"
        fontSize="12px"
        data-hasqtip="97"
      >
        <tspan dy="5.5">Hancock</tspan>
      </text>
      <text
        className="county-label"
        x="682"
        y="264"
        textAnchor="middle"
        fontFamily="Roboto"
        stroke="none"
        fill="#000000"
        fontSize="12px"
        data-hasqtip="98"
      >
        <tspan dy="5.5">Mineral</tspan>
      </text>
      <text
        className="county-label"
        x="517"
        y="483"
        textAnchor="middle"
        fontFamily="Roboto"
        stroke="none"
        fill="#000000"
        fontSize="12px"
        data-hasqtip="99"
      >
        <tspan dy="5.5">Pocahontas</tspan>
      </text>
      <text
        className="county-label"
        x="413"
        y="404"
        textAnchor="middle"
        fontFamily="Roboto"
        stroke="none"
        fill="#000000"
        fontSize="12px"
        data-hasqtip="100"
      >
        <tspan dy="5.5">Braxton</tspan>
      </text>
      <text
        className="county-label"
        x="913"
        y="297"
        textAnchor="middle"
        fontFamily="Roboto"
        stroke="none"
        fill="#000000"
        fontSize="12px"
        data-hasqtip="101"
      >
        <tspan dy="5.5">Jefferson</tspan>
      </text>
      <text
        className="county-label"
        x="488"
        y="239"
        textAnchor="middle"
        fontFamily="Roboto"
        stroke="none"
        fill="#000000"
        fontSize="12px"
        data-hasqtip="102"
      >
        <tspan dy="5.5">Marion</tspan>
      </text>
      <text
        className="county-label"
        x="445"
        y="626"
        textAnchor="middle"
        fontFamily="Roboto"
        stroke="none"
        fill="#000000"
        fontSize="12px"
        data-hasqtip="103"
      >
        <tspan dy="5.5">Monroe</tspan>
      </text>
      <text
        className="county-label"
        x="489"
        y="165"
        textAnchor="middle"
        fontFamily="Roboto"
        stroke="none"
        fill="#000000"
        fontSize="12px"
        data-hasqtip="104"
      >
        <tspan dy="5.5">Marshall</tspan>
      </text>
      <text
        className="county-label"
        x="262"
        y="371"
        textAnchor="middle"
        fontFamily="Roboto"
        stroke="none"
        fill="#000000"
        fontSize="12px"
        data-hasqtip="105"
      >
        <tspan dy="5.5">Jackson</tspan>
      </text>
      <text
        className="county-label"
        x="776"
        y="190"
        textAnchor="middle"
        fontFamily="Roboto"
        stroke="none"
        fill="#000000"
        fontSize="12px"
        data-hasqtip="106"
      >
        <tspan dy="5.5">Morgan</tspan>
      </text>
      <text
        className="county-label"
        x="490"
        y="365"
        textAnchor="middle"
        fontFamily="Roboto"
        stroke="none"
        fill="#000000"
        fontSize="12px"
        data-hasqtip="107"
      >
        <tspan dy="5.5">Upshur</tspan>
      </text>
      <text
        className="county-label"
        x="224"
        y="574"
        textAnchor="middle"
        fontFamily="Roboto"
        stroke="none"
        fill="#000000"
        fontSize="12px"
        data-hasqtip="108"
      >
        <tspan dy="5.5">Logan</tspan>
      </text>
      <text
        className="county-label"
        x="258"
        y="533"
        textAnchor="middle"
        fontFamily="Roboto"
        stroke="none"
        fill="#000000"
        fontSize="12px"
        data-hasqtip="109"
      >
        <tspan dy="5.5">Boone</tspan>
      </text>
    </svg>
  );
}

export default WvMap;
